import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { getSettings } from '../../util/getSettings';
import { QsStateManager } from '../../util/urls';
import { getFiltersFromSource } from '../../util/filters';
import { filtersUpdated, sortByUpdated, ascUpdated } from '../../redux/actions/filters';

function SortByDropdown() {
    const settings = getSettings(['century', 'settings']);
    const labels = getSettings(['century', 'labels'], true);
    const filters = useSelector((state) => state.filters);
    const [currentFilters, setCurrentFilters] = useState(getFiltersFromSource(filters));    
    const sortTypes = JSON.parse(settings.sortTypes);

    const { sortBy: currentSort } = currentFilters;
    

    const [selectedSort, setSelectedSort] = useState('');



    const dispatch = useDispatch();

    useEffect(()=>{        
        setSelectedSort(currentSort);
    }, [currentSort])

    const handleSortChange = (sort) =>{
        
        setCurrentFilters({ ...currentFilters, sortBy: sort });
        dispatch(sortByUpdated(sort));
        dispatch(filtersUpdated());
        new QsStateManager().addParam('sb', sort).addFilters(filters).doUpdate();

    }
    
    const onSortChange = (event) => {
        const target = event.target;
        const sortByValue = target.value;
        setSelectedSort(sortByValue)
        handleSortChange(sortByValue)
            
    };


    return (
        <div className='sort-by-wrapper'>
            <div className="sort-by-dropdown form-group form-inline mb-0">
                <label className="text-primary mb-0" htmlFor="sortItemsBy">{labels.sortByDropdownLabel}</label>
                <select
                    className="form-control"
                    id="sortItemsBy"
                    name="sortItemsBy"
                    onChange={onSortChange}
                    defaultValue={currentSort}
                >
                {Object.keys(sortTypes).map((keyName, i) => (
                    <option key={keyName} value={keyName}>{sortTypes[keyName]}</option>
                ))}
                </select>
            </div>

            
        </div>
    )
}

export default SortByDropdown